<template>
  <main id="succes-regis--wrapper">
      <div id="succes-regis-page">
          <div id="success-register-independent" class="container py-5">
              <div class="row text-center justify-content-center">
                  <div class="col-md-4">
                      <div class="row py-4">
                          <div class="col">
                            <button class="btn btn-red" @click="registerUsers">Register Users</button>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- <popup-giveaway></popup-giveaway> -->
  </main>
</template>

<script>
import axios from 'axios';

export default {
  methods: {
    async registerUsers() {
      const phoneNumberBase = '62800000000'; // Base phone number
      const url = `${api_url}/member/register/independent/otp`; // Your endpoint URL
      const promises = [];

      for (let i = 1; i <= 100; i++) {
        const userData = {
          phone: phoneNumberBase + i,
          name: 'User' + i,
          email: 'user' + i + '@example.com',
          province_id: '6063ff9af1c2596ad761b702',
          city_id: '6063ff9df1c2596ad761b707',
          motor_id: '6086559745065967a17ced77',
          bike_category: 'matic',
          motor_year: '2020',
          club_name1: 'Club1',
          agree: true,
          agree_tnc: true,
          otp_number: 909090,
          pin: 123123,
          pin_confirmation: 123123,
        };

        // Push the axios post request to promises array
        promises.push(axios.post(url, userData));
      }

      try {
        // Execute all requests simultaneously
        const responses = await Promise.all(promises);
        console.log('All users registered successfully', responses);
      } catch (error) {
        console.error('Error in registering users', error);
      }
    }
  }
}
</script>

<style scoped lang="scss">
#succes-regis-page{
  background: #000000;
  .desc-info{
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 30px;
      text-align: center;
      color: #FFFFFF;
  }
  .detail {
      font-style: normal;
      font-weight: 300;
      font-size: 15px;
      line-height: 24px;
      text-align: center;
      color: #FFFFFF;
  }
  .title-row{
      background: #181818;
      opacity: 0.95;
      font-family: Manrope;
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 42px;
      color: #FFFFFF;
  }
  .info-row{
      background: #1E1E1E;
  }
  #img-info{
      max-height: 25px;
  }
  #img-check{
      max-height: 60px;
  }
  .btn{
      width: 161px;
      height: 50px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
  }
  .btn:hover {
      color: white;
      text-decoration: none;
  }
  .btn-white{
      border: 1px solid #DBDBDB;
      box-sizing: border-box;
      border-radius: 10px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      color: #E61B33;
  }
  .btn-red{
      background: #E61B33;
      border-radius: 10px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      color: #FFFFFF;
  }
}
</style>